export enum Language {
  English = 'English',
  Spanish = 'Spanish',
}
